<template>
  <div>
    <div id="list" v-if="viewType == VIEW_LIST">
      <div class="row center-block">
        <div class="col-md-12">
          <div class="box">
            <div class="box-header">
                <label for="recordPerPage" class="col-sm-1 col-md-1 col-lg-1" style="margin-top: 10px; text-align:left">Show</label>
                <div class="col-sm-2 col-md-2 col-lg-1" style="padding-left:0px;">
                  <select v-on:change="changePageSize" ref="recordPerPage" class="form-control">
                    <option v-if="inquiryParam.pageSize == 5" selected>5</option><option v-else>5</option>
                    <option v-if="inquiryParam.pageSize == 10" selected>10</option><option v-else>10</option>
                    <option v-if="inquiryParam.pageSize == 20" selected>20</option><option v-else>20</option>
                    <option v-if="inquiryParam.pageSize == 50" selected>50</option><option v-else>50</option>
                    <option v-if="inquiryParam.pageSize == 100" selected>100</option><option v-else>100</option>
                  </select>
                </div>          
                <div class="box-tools">              
                  <button v-on:click="onCreate" class="btn btn-primary">Create</button>
                  <button v-on:click="inquiry" class="btn btn-warning">Search</button>
                </div>
            </div>        
            <div class="box-body no-padding table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="width:15px;text-align:right;">#</th>
                    <th style="text-align:center;">Action</th>
                    <th style="text-align:left;">Name</th>
                    <th style="text-align:left;">Project</th>
                    <th style="text-align:left;">Type</th>
                    <th style="text-align:left;">Category</th>
                    <th style="text-align:right;">Price</th>
                    <th style="text-align:right;">Tax(%)</th>
                    <th style="text-align:right;">Discount</th>
                    <th style="text-align:center;">Currency</th>
                    <th style="text-align:center;">Valid From</th>
                    <th style="text-align:center;">Valid To</th>
                    <th style="text-align:left;">Period</th>
                    <th style="text-align:center;">Max Visited</th>
                    <th style="text-align:center;">Free</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in listData" v-bind:key="i">
                    <td style="width:15px;text-align:right;">{{ startSequence + i + 1}}</td>
                    <td style="text-align:center;" nowrap>
                      <a href="#" v-on:click="onDisplay(row)" ref="displayRow" style="padding-right:5px">
                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                      </a>                      
                      <a href="#" v-on:click="onEdit(row)" ref="editRow" style="padding-right:5px">
                        <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                      </a>
                      <a href="#" v-on:click="onDelete(row)" ref="deleteRow" style="padding-right:5px">
                        <span class="icon ion-ios-trash" data-toggle="tooltip" data-placement="right" title="Delete"></span>
                      </a>
                    </td>
                    <td style="text-align:left;">{{ row.name }}</td>
                    <td style="text-align:left;">{{ row.projectName }}</td>
                    <td style="text-align:left;">{{ row.membershipTypeName }}</td>
                    <td style="text-align:left;">{{ row.membershipCategoryName }}</td>
                    <td style="text-align:right;">{{ row.price }}</td>
                    <td style="text-align:right;">{{ row.tax }}</td>
                    <td style="text-align:right;">{{ row.discount }}</td>
                    <td style="text-align:center;">{{ row.currencyName }}</td>
                    <td style="text-align:center;">{{ row.validFrom }}</td>
                    <td style="text-align:center;">{{ row.validTo }}</td>
                    <td style="text-align:left;">{{ row.period }}</td>
                    <td style="text-align:center;">{{ row.maxVisited }}</td>
                    <td style="text-align:center;"><input type="checkbox" :checked= row.freeFlag></td>
                    <td hidden>{{ row.id }}</td>
                    <td hidden>{{ row.projectId }}</td>
                    <td hidden>{{ row.membershipTypeId }}</td>
                    <td hidden>{{ row.membershipCategoryId }}</td>
                    <td hidden>{{ row.currencyId }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="box-footer">
              <div class="form-group">
                <label style="width:25px;text-align:right;">
                    <a href="#"><i v-on:click="changePage(1)" class="icon ion-ios-rewind"></i></a>
                </label>
                <label style="width:35px;text-align:center;">
                    <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
                </label>
                <label>
                    Page
                </label>
                <label>
                    <input v-model="inquiryParam.CurrentPageNumber" v-on:keyup.enter="gotoPage($event)" type="text" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
                </label>
                <label id="TotalPageText">
                  {{ totalPages }}                
                </label>
                <label style="width:35px;text-align:center;">
                    <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
                </label>
                <label style="width:25px;text-align:left;">
                    <a href="#"><i v-on:click="changePage(totalPages)" class="icon ion-ios-fastforward"></i></a>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div id="form" v-if="viewType == VIEW_FORM">
        <div class="row center-block" style="margin-top:10px;">
          <div class="col-md-12">
            <div class="box box-info no-border">
              <form @submit.prevent class="form-horizontal">
                <input type="hidden" id="inputId" v-model="formData.id">
                <input type="hidden" id="inputProjectId" v-model="formData.projectId">
                <input type="hidden" id="inputTypeId" v-model="formData.typeId">
                <input type="hidden" id="inputCategoryId" v-model="formData.categoryId">
                <input type="hidden" id="inputCurrencyId" v-model="formData.currencyId">
                <div class="box-body">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="inputName" class="col-sm-3 control-label">Name</label>
                        <div class="col-sm-9">
                          <input :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Membership Name" v-model="formData.name">
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputProject" class="col-sm-3 control-label">Project</label>
                        <div class="col-sm-9">
                          <select v-model="formData.projectId" class="form-control" :disabled="viewMode == MODE_VIEW">
                            <option v-for="(row, i) in listProject" v-bind:key="i" v-bind:value="row.id">
                              {{ row.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputType" class="col-sm-3 control-label">Type</label>
                        <div class="col-sm-9">
                          <select v-model="formData.typeId" class="form-control" :disabled="viewMode == MODE_VIEW">
                            <option v-for="(row, i) in listMembershipType" v-bind:key="i" v-bind:value="row.id">
                              {{ row.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputCategory" class="col-sm-3 control-label">Category</label>
                        <div class="col-sm-9">
                          <select v-model="formData.categoryId" class="form-control" :disabled="viewMode == MODE_VIEW">
                            <option v-for="(row, i) in listMembershipCategory" v-bind:key="i" v-bind:value="row.id">
                              {{ row.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputValidFrom" class="col-sm-3 control-label">Valid From</label>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <datepicker style="width:100%" v-if="showValidFrom" :readonly="true" name="validFrom" :value=formData.validFrom 
                                        :format=DATE_FORMAT :input-attr="{ 'id': 'validFrom', 'disabled': viewMode == MODE_VIEW }"
                                        :input-style="{ 'width': '100%' }"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputValidTo" class="col-sm-3 control-label">Valid To</label>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <datepicker style="width:100%" v-if="showValidTo" :readonly="true" name="validTo" :value=formData.validTo
                                        :format=DATE_FORMAT :input-attr="{ 'id': 'validTo', 'disabled': viewMode == MODE_VIEW }"
                                        :input-style="{ 'width': '100%' }"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="inputPrice" class="col-sm-3 control-label">Price</label>
                        <div class="col-sm-5">
                          <input @keyup="formattingNumber($event)" ref="inputPrice" :readonly="viewMode == MODE_VIEW" class="form-control" id="inputPrice" placeholder="" v-model="formData.price">
                        </div>
                        <div class="col-sm-offset-1 col-sm-3">
                          <div class="checkbox">
                            <label>
                              <input :disabled="viewMode == MODE_VIEW" type="checkbox" id="inputFreeFlag" v-model="formData.freeFlag">
                              Free
                            </label>
                          </div>
                        </div>                        
                      </div>
                      <div class="form-group">
                        <label for="inputTax" class="col-sm-3 control-label">Tax</label>
                        <div class="col-sm-9">
                          <input @keyup="formattingNumber($event)" ref="inputTax" :readonly="viewMode == MODE_VIEW" class="form-control" id="inputTax" placeholder="" v-model="formData.tax">
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputDiscount" class="col-sm-3 control-label">Discount</label>
                        <div class="col-sm-9">
                          <input @keyup="formattingNumber($event)" ref="inputDiscount" :readonly="viewMode == MODE_VIEW ? true : false" class="form-control" id="inputDiscount" placeholder="" v-model="formData.discount">
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputCurrency" class="col-sm-3 control-label">Currency</label>
                        <div class="col-sm-9">
                          <select v-model="formData.currencyId" class="form-control" :disabled="viewMode == MODE_VIEW">
                            <option v-for="(row, i) in listCurrency" v-bind:key="i" v-bind:value="row.id">
                              {{ row.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputPeriod" class="col-sm-3 control-label">Period</label>
                        <div class="col-sm-9">
                          <select v-model="formData.period" class="form-control" :disabled="viewMode == MODE_VIEW">
                            <option v-for="(row, i) in listPeriod" v-bind:key="i" v-bind:value="row.name">
                              {{ row.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputMaxVisited" class="col-sm-3 control-label">Max Visited</label>
                        <div class="col-sm-9">
                          <input @keyup="formattingNumber($event)" ref="inputMaxVisited" :readonly="viewMode == MODE_VIEW ? true : false" class="form-control" id="inputMaxVisited" placeholder="" v-model="formData.maxVisited">
                        </div>
                      </div>                                                                                    
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="nav-tabs-custom">
                        <ul class="nav nav-tabs">
                          <li class="active"><a href="#tab_1" data-toggle="tab" aria-expanded="true">Product</a></li>
                        </ul>
                      </div>
                      <div class="tab-content">
                        <div class="tab-pane active" id="tab_1">
                          <div class="col-md-12">
                            <div class="box no-border">
                              <div class="box-header" style="height:40px;">          
                                <div class="box-tools">              
                                  <button @click="onCreateProduct" class="btn btn-primary">Create</button>
                                </div>
                              </div>                              
                              <div class="box-body no-padding table-responsive">
                                <table class="table table-striped">
                                  <thead>
                                    <tr>
                                      <th style="width:10px;text-align:center">#</th>
                                      <th style="width:80px;text-align:center;">Action</th>
                                      <th style="text-align:center;">Name</th>
                                      <th style="text-align:center;">Description</th>
                                      <th style="text-align:center;">Valid From</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(row, i) in listMembershipProduct" v-bind:key="i">
                                      <td style="width:10px;text-align:right">{{ startSequence + i + 1}}</td>
                                      <td style="width:80px;text-align:center">
                                        <a href="#" v-on:click="onDisplayProduct(row)" ref="displayRowProduct" style="padding-right:5px">
                                          <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                                        </a>
                                        <a href="#" v-on:click="onEditProduct(row)" ref="editRowProduct" style="padding-right:5px">
                                          <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                                        </a>
                                        <!-- <a href="#" v-on:click="onDeleteProduct(row)" ref="deleteRowProduct" style="padding-right:5px">
                                          <span class="icon ion-ios-trash" data-toggle="tooltip" data-placement="right" title="Delete"></span>
                                        </a>                                         -->
                                      </td>
                                      <td style="text-align:left;">{{ row.name }}</td>
                                      <td style="text-align:left;">{{ row.description }}</td>
                                      <td style="text-align:center;">{{ row.validFrom }}</td>
                                      <td style="text-align:center;">{{ row.MaxVisited }}</td>
                                      <td hidden>{{ row.id }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>                  
                </div>
                <!-- /.box-body -->
                <div class="box-footer">
                  <div class="box-tools">
                    <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>
                    <button @click="onCancel()" class="btn btn-warning">Cancel</button>
                    <button v-if="viewMode != MODE_VIEW" @click="onSave()" class="btn btn-info pull-right">Save</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onEdit(formData)" class="btn btn-info pull-right">Edit</button>
                  </div>
                </div>
                <!-- /.box-footer -->
              </form>
            </div>          
          </div>
        </div>
      </div> 
    </transition>  
    <transition name="fade">
      <div id="form" v-if="viewType == VIEW_FORM_PRODUCT">
        <div class="row center-block" style="margin-top:10px;">
          <div class="col-md-12">
            <div class="box box-info no-border">
              <form @submit.prevent class="form-horizontal">
                <input type="hidden" id="inputId" v-model="formDataProduct.id">
                <input type="hidden" id="inputMembershipId" v-model="formDataProduct.membershipId">
                <div class="box-body">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="inputName" class="col-sm-3 control-label">Name</label>
                        <div class="col-sm-9">
                          <input :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" v-model="formDataProduct.name">
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputDescription" class="col-sm-3 control-label">Description</label>
                        <div class="col-sm-9">
                          <input :disabled="viewMode == MODE_VIEW" class="form-control" id="inputDescription" v-model="formDataProduct.description">
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputValidFromProduct" class="col-sm-3 control-label">Valid From</label>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <datepicker style="width:100%" v-if="showValidFromProduct" :readonly="true" name="validFrom" :value=formDataProduct.validFrom 
                                        :format=DATE_FORMAT :input-attr="{ 'id': 'validFromProduct', 'disabled': viewMode == MODE_VIEW ? true : false }"
                                        :input-style="{ 'width': '100%' }"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">                                                                                    
                    </div>
                  </div>                  
                </div>
                <!-- /.box-body -->
                <div class="box-footer">
                  <div class="box-tools">
                    <button @click="onBackProduct()" class="btn btn-default" style="margin-right:15px;">Back</button>
                    <button @click="onCancelProduct()" class="btn btn-warning">Cancel</button>
                    <button v-if="viewMode != MODE_VIEW" @click="onSaveProduct()" class="btn btn-info pull-right">Save</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onEditProduct(formData)" class="btn btn-info pull-right">Edit</button>
                  </div>
                </div>
                <!-- /.box-footer -->
              </form>
            </div>          
          </div>
        </div>
      </div> 
    </transition>
  </div> 
</template>

<script>
import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'// https://github.com/sweetalert2/sweetalert2  https://sweetalert2.github.io/
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'
import utilities from '../../utilities'

const VIEW_LIST = 'list'
const VIEW_FORM = 'form'
const MODE_NONE = 'none'
const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'
const VIEW_FORM_PRODUCT = 'formProduct'

export default {
  name: 'Membership',
  components: {
    datepicker
  },
  data() {
    return {
      DATE_FORMAT: config.dateFormat,
      VIEW_LIST: VIEW_LIST,
      VIEW_FORM: VIEW_FORM,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      VIEW_FORM_PRODUCT: VIEW_FORM_PRODUCT,
      column: '',
      item: null,
      listData: null,
      listDataTemp: null,
      listProject: null,
      listCurrency: null,
      listMembershipType: null,
      listMembershipCategory: null,
      listPeriod: null,
      listMembershipProduct: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'ASC',
        SortExpression: 'Name',
        WhereClauseByProject: ''
      },
      viewType: VIEW_LIST,
      viewMode: MODE_NONE,
      formData: {
        id: '',
        name: '',
        projectId: '',
        typeId: '',
        categoryId: '',
        price: '',
        tax: '',
        discount: '',
        validFrom: '',
        validTo: '',
        currencyId: '',
        period: '',
        maxVisited: '',
        freeFlag: ''
      },
      formDataProduct: {
        id: '',
        name: '',
        description: '',
        validFrom: ''
      },
      showValidFrom: false,
      showValidTo: false,
      showValidFromProduct: false
    }
  },
  created() {
    this.viewType = VIEW_LIST
    this.inquiry()
    this.getPeriod()
  },
  mounted() {
    this.$refs.recordPerPage.value = this.inquiryParam.PageSize
    this.$root.$on('inquiryMembershipByProject', (projectIds) => {
      this.projectIds = projectIds
      return this.inquiry()
    })
  },
  computed: {
  },
  methods: {
    changePageSize(evt) {
      this.inquiryParam.PageSize = evt.target.value
      this.inquiryParam.CurrentPageNumber = 1
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    gotoPage(evt) {
      if (evt.target.value > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else if (evt.target.value < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    changePage(page) {
      if (page < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      } else if (page > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else {
        this.inquiryParam.CurrentPageNumber = page
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    inquiry() {
      this.inquiryMembership()
    },
    inquiryMembership() {
      this.inquiryParam.WhereClauseByProject = ''
      if (this.$store.state.userInfo.projects && this.$store.state.userInfo.projects.length > 0) {
        this.inquiryParam.WhereClauseByProject = 'ProjectId IN (' + this.$store.state.userInfo.projects.join() + ')'
        this.inquiryParam.WhereClauseByProject = this.inquiryParam.WhereClause === '' ? this.inquiryParam.WhereClauseByProject : this.inquiryParam.WhereClauseByProject + ' AND '
      }

      api
        .request('Guest', 'get', '/api/Membership/Inquiry?WhereClause=' + this.inquiryParam.WhereClauseByProject + this.inquiryParam.WhereClause +
                                '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
                                '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
        .then(response => {
          this.total = response.data.totalRows
          this.totalPages = response.data.totalPages
          this.listDataTemp = response.data.entity
          this.listData = []
        })
        .then(response => {
          let arrProject = []
          let arrMembershipType = []
          let arrMembershipCategory = []
          let arrCurrency = []

          this.listDataTemp.forEach(itemMembership => {
            // Populate project
            arrProject.push(itemMembership.projectId)
            var arrProjectUnique = arrProject.filter(function(item, index) {
              return arrProject.indexOf(item) >= index
            })
            arrProject = arrProjectUnique

            // Populate membership type
            arrMembershipType.push(itemMembership.typeId)
            var arrMembershipTypeUnique = arrMembershipType.filter(function(item, index) {
              return arrMembershipType.indexOf(item) >= index
            })
            arrMembershipType = arrMembershipTypeUnique

            // Populate membership category
            arrMembershipCategory.push(itemMembership.categoryId)
            var arrMembershipCategoryUnique = arrMembershipCategory.filter(function(item, index) {
              return arrMembershipCategory.indexOf(item) >= index
            })
            arrMembershipCategory = arrMembershipCategoryUnique

            // Populate currency
            arrCurrency.push(itemMembership.currencyId)
            var arrCurrencyUnique = arrCurrency.filter(function(item, index) {
              return arrCurrency.indexOf(item) >= index
            })
            arrCurrency = arrCurrencyUnique

            this.getProject(arrProject, arrMembershipType, arrMembershipCategory, arrCurrency)
          })
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getProject(arrProject, arrMembershipType, arrMembershipCategory, arrCurrency) {
      let whereClause = 'id in (' + arrProject.join(',') + ')'
      api
        .request('Account', 'get', '/api/Project/Inquiry?WhereClause=' + whereClause + '&PageSize=' + arrProject.length +
                                      '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
        .then(response => {
          var data = response.data
          this.listProject = data.entity
        })
        .then(response => {
          this.getMembershipType(arrMembershipType, arrMembershipCategory, arrCurrency)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getMembershipType(arrMembershipType, arrMembershipCategory, arrCurrency) {
      let whereClause = 'id in (' + arrMembershipType.join(',') + ')'
      api
        .request('Guest', 'get', '/api/MembershipType/Inquiry?WhereClause=' + whereClause + '&PageSize=' + arrMembershipType.length +
                                      '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
        .then(response => {
          var data = response.data
          this.listMembershipType = data.entity
        })
        .then(response => {
          this.getMembershipCategory(arrMembershipCategory, arrCurrency)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getMembershipCategory(arrMembershipCategory, arrCurrency) {
      let whereClause = 'id in (' + arrMembershipCategory.join(',') + ')'
      api
        .request('Guest', 'get', '/api/MembershipCategory/Inquiry?WhereClause=' + whereClause + '&PageSize=' + arrMembershipCategory.length +
                                      '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
        .then(response => {
          var data = response.data
          this.listMembershipCategory = data.entity
        })
        .then(response => {
          this.getCurrency(arrCurrency)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getCurrency(arrCurrency) {
      let whereClause = 'id in (' + arrCurrency.join(',') + ')'
      api
        .request('Account', 'get', '/api/Currency/Inquiry?WhereClause=' + whereClause + '&PageSize=' + arrCurrency.length +
                                      '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
        .then(response => {
          var data = response.data
          this.listCurrency = data.entity
        })
        .then(response => {
          this.combineInquiry()
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    combineInquiry() {
      var currencyName, projectName, membershipTypeName, membershipCategoryName
      this.listDataTemp.forEach(itemMembership => {
        currencyName = ''
        this.listCurrency.some(function(itemCurrency, index) {
          if (itemMembership.currencyId === itemCurrency.id) {
            currencyName = itemCurrency.name
          }
        })
        projectName = ''
        this.listProject.some(function(itemProject, index) {
          if (itemMembership.projectId === itemProject.id) {
            projectName = itemProject.name
          }
        })
        membershipTypeName = ''
        this.listMembershipType.some(function(itemMembershipType, index) {
          if (itemMembership.typeId === itemMembershipType.id) {
            membershipTypeName = itemMembershipType.name
          }
        })
        membershipCategoryName = ''
        this.listMembershipCategory.some(function(itemMembershipCategory, index) {
          if (itemMembership.categoryId === itemMembershipCategory.id) {
            membershipCategoryName = itemMembershipCategory.name
          }
        })
        itemMembership.currencyName = currencyName
        itemMembership.projectName = projectName
        itemMembership.membershipTypeName = membershipTypeName
        itemMembership.membershipCategoryName = membershipCategoryName
      })
      this.listData = this.listDataTemp
    },
    getPeriod() {
      api
        .request('Guest', 'get', '/api/Membership/GetPeriod', null)
        .then(response => {
          var data = response.data
          this.listPeriod = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    initForm() {
      this.formData.id = 0
      this.formData.name = ''
      this.formData.projectId = 0
      this.formData.typeId = 0
      this.formData.categoryId = 0
      this.formData.price = ''
      this.formData.tax = ''
      this.formData.discount = ''
      this.formData.validFrom = ''
      this.formData.validTo = ''
      this.formData.currencyId = 0
      this.formData.period = ''
      this.formData.freeFlag = false

      this.showValidFrom = false
      this.$nextTick(() => {
        this.showValidFrom = true
      })
      this.showValidTo = false
      this.$nextTick(() => {
        this.showValidTo = true
      })
    },
    onCreate() {
      this.initForm()
      this.viewType = VIEW_FORM
      this.viewMode = MODE_CREATE
      this.getComboBoxProject()
      this.getComboBoxMembershipType()
    },
    getComboBoxProject() {
      api
        .request('Account', 'get', '/api/Project/Inquiry?WhereClause=&PageSize=99999&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
        .then(response => {
          var data = response.data
          this.listProject = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getComboBoxMembershipType() {
      api
        .request('Guest', 'get', '/api/MembershipType/Inquiry?WhereClause=&PageSize=999999&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
        .then(response => {
          var data = response.data
          this.listMembershipType = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onDisplay(row) {
      this.viewType = VIEW_FORM
      this.viewMode = MODE_VIEW

      this.formData.id = row.id
      this.formData.name = row.name
      this.formData.projectId = row.projectId
      this.formData.typeId = row.typeId
      this.formData.categoryId = row.categoryId
      this.formData.validFrom = row.validFrom
      this.formData.validTo = row.validTo
      this.formData.price = row.price
      this.formData.tax = row.tax
      this.formData.discount = row.discount
      this.formData.currencyId = row.currencyId
      this.formData.currencyName = row.currencyName
      this.formData.period = row.period
      this.formData.freeFlag = row.freeFlag

      this.showValidFrom = false
      this.$nextTick(() => {
        this.showValidFrom = true
      })
      this.showValidTo = false
      this.$nextTick(() => {
        this.showValidTo = true
      })

      this.getProduct(row.id)
    },
    onEdit(row) {
      this.viewType = VIEW_FORM
      this.viewMode = MODE_UPDATE

      this.formData.id = row.id
      this.formData.name = row.name
      this.formData.projectId = row.projectId
      this.formData.typeId = row.typeId
      this.formData.categoryId = row.categoryId
      this.formData.validFrom = row.validFrom
      this.formData.validTo = row.validTo
      this.formData.price = row.price
      this.formData.tax = row.tax
      this.formData.discount = row.discount
      this.formData.currencyId = row.currencyId
      this.formData.currencyName = row.currencyName
      this.formData.period = row.period
      this.formData.maxVisited = row.maxVisited
      this.formData.freeFlag = row.freeFlag

      this.showValidFrom = false
      this.$nextTick(() => {
        this.showValidFrom = true
      })
      this.showValidTo = false
      this.$nextTick(() => {
        this.showValidTo = true
      })

      this.getProduct(row.id)
    },
    onCancel() {
      if (this.viewMode === MODE_CREATE) {
        this.initForm()
      } else if (this.viewMode === MODE_UPDATE) {
        this.onDisplay(this.formData)
      }
    },
    onBack() {
      this.inquiry()
      this.viewType = VIEW_LIST
      this.viewMode = MODE_NONE
    },
    onDelete(data) {
      SweetAlert.fire({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: true
      })
      .then((result) => {
        if (result.value) {
          var res = this.delete(data)
          SweetAlert.fire('Deleted', res.message, res.status)
        } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
          SweetAlert.fire('Cancelled', 'Your data is still exist', 'info')
        }
      })
    },
    onSave() {
      var reqData = {
        Id: this.formData.id,
        Name: this.formData.name,
        ProjectId: this.formData.projectId,
        TypeId: this.formData.typeId,
        CategoryId: this.formData.categoryId,
        ValidFrom: $('#validFrom').val(), // this.formData.validFrom,
        ValidTo: $('#validTo').val(), // this.formData.validTo,
        Price: this.formData.price,
        Tax: this.formData.tax,
        Discount: this.formData.discount,
        CurrencyId: this.formData.currencyId,
        CurrencyName: this.formData.currencyName,
        Period: this.formData.period,
        MaxVisited: this.formData.maxVisited,
        FreeFlag: this.formData.freeFlag
      }

      var status = 'success'
      var message = ''
      var method = ''
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'Create'
          break
        case MODE_UPDATE:
          method = 'Update'
          break
      }

      api
        .request('Guest', 'post', '/api/Membership/' + method, reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })

      if (this.viewMode === MODE_CREATE) {
        this.initForm()
      }
    },
    delete(data) {
      var status = ''
      var message = ''
      var reqData = {
        Id: data.id,
        Name: data.name
      }
      api.request('Guest', 'post', '/api/Membership/Delete', reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage
          this.inquiry()
        })
        .catch(error => {
          status = 'error'
          message = 'Error happens when call API delete: ' + error.message
        })
      return { status: status, message: message }
    },
    formattingNumber(evt) {
      // When the arrow keys are pressed, etc..., abort.
      if ($.inArray(evt.keyCode, [9, 38, 40, 37, 39]) !== -1) {
        return
      }

      var input = this.$refs[evt.target.id].value
      var inputNumber = utilities.ParseNumber(input)
      this.$refs[evt.target.id].value = utilities.DisplayNumber(inputNumber)
      switch (evt.target.id) {
        case 'inputPrice':
          this.formData.price = utilities.DisplayNumber(inputNumber)
          break
        case 'inputTax':
          this.formData.tax = utilities.DisplayNumber(inputNumber)
          break
        case 'inputDiscount':
          this.formData.discount = utilities.DisplayNumber(inputNumber)
          break
        default:
          break
      }
    },
    getProduct(membershipId) {
      api
        .request('Guest', 'get', '/api/Membership/GetProduct?MembershipId=' + membershipId, null)
        .then(response => {
          var data = response.data
          this.listMembershipProduct = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onCreateProduct() {
      this.viewType = VIEW_FORM_PRODUCT
      this.viewMode = MODE_CREATE
      this.formDataProduct.id = 0
      this.formDataProduct.membershipId = this.formData.id
      this.formDataProduct.name = ''
      this.formDataProduct.description = ''
      this.formDataProduct.validFrom = ''

      this.showValidFromProduct = false
      this.$nextTick(() => {
        this.showValidFromProduct = true
      })
    },
    onDisplayProduct(row) {
      this.viewType = VIEW_FORM_PRODUCT
      this.viewMode = MODE_VIEW

      this.formDataProduct.id = row.id
      this.formDataProduct.membershipId = row.membershipId
      this.formDataProduct.name = row.name
      this.formDataProduct.description = row.description
      this.formDataProduct.validFrom = row.validFrom

      this.showValidFromProduct = false
      this.$nextTick(() => {
        this.showValidFromProduct = true
      })
    },
    onEditProduct(row) {
      this.viewType = VIEW_FORM_PRODUCT
      this.viewMode = MODE_UPDATE

      this.formDataProduct.id = row.id
      this.formDataProduct.membershipId = row.membershipId
      this.formDataProduct.name = row.name
      this.formDataProduct.description = row.description
      this.formDataProduct.validFrom = row.validFrom

      this.showValidFromProduct = false
      this.$nextTick(() => {
        this.showValidFromProduct = true
      })
    },
    onCancelProduct() {
      if (this.viewMode === MODE_CREATE) {
        this.initForm()
      } else if (this.viewMode === MODE_UPDATE) {
        this.onDisplayProduct(this.formDataProduct)
      }
    },
    onBackProduct() {
      this.viewType = VIEW_FORM
      this.viewMode = MODE_VIEW
      this.onDisplay(this.formData)
    },
    onSaveProduct() {
      var reqData = {
        Id: this.formDataProduct.id,
        MembershipId: this.formDataProduct.membershipId,
        Name: this.formDataProduct.name,
        Description: this.formDataProduct.description,
        ValidFrom: $('#validFromProduct').val() // this.formDataProduct.validFrom
      }

      var status = 'success'
      var message = ''
      var method = ''
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'CreateProduct'
          break
        case MODE_UPDATE:
          method = 'UpdateProduct'
          break
      }

      api
        .request('Guest', 'post', '/api/Membership/' + method, reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)

          if (resData.returnStatus) {
            this.viewMode = MODE_VIEW
            this.viewType = VIEW_FORM_PRODUCT
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    }
  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// Membership.vue?4050f706